import { create } from "zustand";
import { devtools } from "zustand/middleware";

const getInitialUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch {
    return null;
  }
};

export const useUserStore = create(
  devtools(
    (set) => ({
      user: getInitialUser(),
      setUser: (user) => set({ user }),
      connectIntercom: () =>
        set((state) => ({
          user: { ...state.user, has_intercom_platform: true },
        })),
      connectZendesk: () =>
        set((state) => ({
          user: { ...state.user, has_zendesk_platform: true },
        })),
      connectGorgias: () =>
        set((state) => ({
          user: { ...state.user, has_gorgias_platform: true },
        })),
    }),
    { name: "useUserStore" }
  )
);
